/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard/settings'
import { Route as DashboardProfileRouteImport } from './routes/_dashboard/profile'
import { Route as DashboardCalendarRouteImport } from './routes/_dashboard/calendar'
import { Route as DashboardAppointmentsRouteImport } from './routes/_dashboard/appointments'
import { Route as DashboardVehiclesIndexRouteImport } from './routes/_dashboard/vehicles/index'
import { Route as DashboardUsersIndexRouteImport } from './routes/_dashboard/users/index'
import { Route as DashboardRequestsIndexRouteImport } from './routes/_dashboard/requests/index'
import { Route as DashboardCasesIndexRouteImport } from './routes/_dashboard/cases/index'
import { Route as DashboardVehiclesIdRouteImport } from './routes/_dashboard/vehicles/$id'
import { Route as DashboardUsersIdRouteImport } from './routes/_dashboard/users/$id'
import { Route as DashboardRequestsIdRouteImport } from './routes/_dashboard/requests/$id'
import { Route as DashboardConfigurationSourcesRouteImport } from './routes/_dashboard/configuration/sources'
import { Route as DashboardConfigurationCaseTypesRouteImport } from './routes/_dashboard/configuration/case-types'
import { Route as DashboardCasesIdRouteImport } from './routes/_dashboard/cases/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAppointmentsRoute = DashboardAppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardVehiclesIndexRoute = DashboardVehiclesIndexRouteImport.update({
  id: '/vehicles/',
  path: '/vehicles/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardUsersIndexRoute = DashboardUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRequestsIndexRoute = DashboardRequestsIndexRouteImport.update({
  id: '/requests/',
  path: '/requests/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCasesIndexRoute = DashboardCasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardVehiclesIdRoute = DashboardVehiclesIdRouteImport.update({
  id: '/vehicles/$id',
  path: '/vehicles/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardUsersIdRoute = DashboardUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardRequestsIdRoute = DashboardRequestsIdRouteImport.update({
  id: '/requests/$id',
  path: '/requests/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardConfigurationSourcesRoute =
  DashboardConfigurationSourcesRouteImport.update({
    id: '/configuration/sources',
    path: '/configuration/sources',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardConfigurationCaseTypesRoute =
  DashboardConfigurationCaseTypesRouteImport.update({
    id: '/configuration/case-types',
    path: '/configuration/case-types',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardCasesIdRoute = DashboardCasesIdRouteImport.update({
  id: '/cases/$id',
  path: '/cases/$id',
  getParentRoute: () => DashboardRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof DashboardIndexRoute
  '/login': typeof LoginRoute
  '/appointments': typeof DashboardAppointmentsRoute
  '/calendar': typeof DashboardCalendarRoute
  '/profile': typeof DashboardProfileRoute
  '/settings': typeof DashboardSettingsRoute
  '/cases/$id': typeof DashboardCasesIdRoute
  '/configuration/case-types': typeof DashboardConfigurationCaseTypesRoute
  '/configuration/sources': typeof DashboardConfigurationSourcesRoute
  '/requests/$id': typeof DashboardRequestsIdRoute
  '/users/$id': typeof DashboardUsersIdRoute
  '/vehicles/$id': typeof DashboardVehiclesIdRoute
  '/cases/': typeof DashboardCasesIndexRoute
  '/requests/': typeof DashboardRequestsIndexRoute
  '/users/': typeof DashboardUsersIndexRoute
  '/vehicles/': typeof DashboardVehiclesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/appointments': typeof DashboardAppointmentsRoute
  '/calendar': typeof DashboardCalendarRoute
  '/profile': typeof DashboardProfileRoute
  '/settings': typeof DashboardSettingsRoute
  '/': typeof DashboardIndexRoute
  '/cases/$id': typeof DashboardCasesIdRoute
  '/configuration/case-types': typeof DashboardConfigurationCaseTypesRoute
  '/configuration/sources': typeof DashboardConfigurationSourcesRoute
  '/requests/$id': typeof DashboardRequestsIdRoute
  '/users/$id': typeof DashboardUsersIdRoute
  '/vehicles/$id': typeof DashboardVehiclesIdRoute
  '/cases': typeof DashboardCasesIndexRoute
  '/requests': typeof DashboardRequestsIndexRoute
  '/users': typeof DashboardUsersIndexRoute
  '/vehicles': typeof DashboardVehiclesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/_dashboard/appointments': typeof DashboardAppointmentsRoute
  '/_dashboard/calendar': typeof DashboardCalendarRoute
  '/_dashboard/profile': typeof DashboardProfileRoute
  '/_dashboard/settings': typeof DashboardSettingsRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/cases/$id': typeof DashboardCasesIdRoute
  '/_dashboard/configuration/case-types': typeof DashboardConfigurationCaseTypesRoute
  '/_dashboard/configuration/sources': typeof DashboardConfigurationSourcesRoute
  '/_dashboard/requests/$id': typeof DashboardRequestsIdRoute
  '/_dashboard/users/$id': typeof DashboardUsersIdRoute
  '/_dashboard/vehicles/$id': typeof DashboardVehiclesIdRoute
  '/_dashboard/cases/': typeof DashboardCasesIndexRoute
  '/_dashboard/requests/': typeof DashboardRequestsIndexRoute
  '/_dashboard/users/': typeof DashboardUsersIndexRoute
  '/_dashboard/vehicles/': typeof DashboardVehiclesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/appointments'
    | '/calendar'
    | '/profile'
    | '/settings'
    | '/cases/$id'
    | '/configuration/case-types'
    | '/configuration/sources'
    | '/requests/$id'
    | '/users/$id'
    | '/vehicles/$id'
    | '/cases/'
    | '/requests/'
    | '/users/'
    | '/vehicles/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/appointments'
    | '/calendar'
    | '/profile'
    | '/settings'
    | '/'
    | '/cases/$id'
    | '/configuration/case-types'
    | '/configuration/sources'
    | '/requests/$id'
    | '/users/$id'
    | '/vehicles/$id'
    | '/cases'
    | '/requests'
    | '/users'
    | '/vehicles'
  id:
    | '__root__'
    | '/_dashboard'
    | '/login'
    | '/_dashboard/appointments'
    | '/_dashboard/calendar'
    | '/_dashboard/profile'
    | '/_dashboard/settings'
    | '/_dashboard/'
    | '/_dashboard/cases/$id'
    | '/_dashboard/configuration/case-types'
    | '/_dashboard/configuration/sources'
    | '/_dashboard/requests/$id'
    | '/_dashboard/users/$id'
    | '/_dashboard/vehicles/$id'
    | '/_dashboard/cases/'
    | '/_dashboard/requests/'
    | '/_dashboard/users/'
    | '/_dashboard/vehicles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/profile': {
      id: '/_dashboard/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/calendar': {
      id: '/_dashboard/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof DashboardCalendarRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/appointments': {
      id: '/_dashboard/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof DashboardAppointmentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/vehicles/': {
      id: '/_dashboard/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles/'
      preLoaderRoute: typeof DashboardVehiclesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/users/': {
      id: '/_dashboard/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof DashboardUsersIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/requests/': {
      id: '/_dashboard/requests/'
      path: '/requests'
      fullPath: '/requests/'
      preLoaderRoute: typeof DashboardRequestsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/cases/': {
      id: '/_dashboard/cases/'
      path: '/cases'
      fullPath: '/cases/'
      preLoaderRoute: typeof DashboardCasesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/vehicles/$id': {
      id: '/_dashboard/vehicles/$id'
      path: '/vehicles/$id'
      fullPath: '/vehicles/$id'
      preLoaderRoute: typeof DashboardVehiclesIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/users/$id': {
      id: '/_dashboard/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof DashboardUsersIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/requests/$id': {
      id: '/_dashboard/requests/$id'
      path: '/requests/$id'
      fullPath: '/requests/$id'
      preLoaderRoute: typeof DashboardRequestsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/configuration/sources': {
      id: '/_dashboard/configuration/sources'
      path: '/configuration/sources'
      fullPath: '/configuration/sources'
      preLoaderRoute: typeof DashboardConfigurationSourcesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/configuration/case-types': {
      id: '/_dashboard/configuration/case-types'
      path: '/configuration/case-types'
      fullPath: '/configuration/case-types'
      preLoaderRoute: typeof DashboardConfigurationCaseTypesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/cases/$id': {
      id: '/_dashboard/cases/$id'
      path: '/cases/$id'
      fullPath: '/cases/$id'
      preLoaderRoute: typeof DashboardCasesIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardAppointmentsRoute: typeof DashboardAppointmentsRoute
  DashboardCalendarRoute: typeof DashboardCalendarRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardCasesIdRoute: typeof DashboardCasesIdRoute
  DashboardConfigurationCaseTypesRoute: typeof DashboardConfigurationCaseTypesRoute
  DashboardConfigurationSourcesRoute: typeof DashboardConfigurationSourcesRoute
  DashboardRequestsIdRoute: typeof DashboardRequestsIdRoute
  DashboardUsersIdRoute: typeof DashboardUsersIdRoute
  DashboardVehiclesIdRoute: typeof DashboardVehiclesIdRoute
  DashboardCasesIndexRoute: typeof DashboardCasesIndexRoute
  DashboardRequestsIndexRoute: typeof DashboardRequestsIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardVehiclesIndexRoute: typeof DashboardVehiclesIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAppointmentsRoute: DashboardAppointmentsRoute,
  DashboardCalendarRoute: DashboardCalendarRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardCasesIdRoute: DashboardCasesIdRoute,
  DashboardConfigurationCaseTypesRoute: DashboardConfigurationCaseTypesRoute,
  DashboardConfigurationSourcesRoute: DashboardConfigurationSourcesRoute,
  DashboardRequestsIdRoute: DashboardRequestsIdRoute,
  DashboardUsersIdRoute: DashboardUsersIdRoute,
  DashboardVehiclesIdRoute: DashboardVehiclesIdRoute,
  DashboardCasesIndexRoute: DashboardCasesIndexRoute,
  DashboardRequestsIndexRoute: DashboardRequestsIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardVehiclesIndexRoute: DashboardVehiclesIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
